import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const StyledModalParagraph = styled.div`
  position: relative;
  margin-bottom: 23px;
  line-height: 1.41;
  text-align: center;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
`;
